import React from "react";

// assets importing
import logoBusiness from "../../assets/LogoBusiness.jpg";
import logoProduct from "../../assets/LogoProduct.png";
import logoInstitute from "../../assets/LogoInstitute.jpg";

import jsPDF from "jspdf";
import { font } from "./MyFont.ttf-normal";

// mui icon importing
import CloudDownloadTwoToneIcon from '@mui/icons-material/CloudDownloadTwoTone';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';

const FormContent = () => {

  // TODO: onClick download file
  // TODO: PDF download
  const _onClickDownloadPDF = () => {

    const doc = new jsPDF("p", "mm", "a5");

    // TODO: Header Footer
    doc.addFileToVFS("MyFont.ttf", font);
    doc.addFont("MyFont.ttf", "MyFont", "normal");
    doc.setFont("MyFont");

    doc.setFillColor(0, 35, 149);
    doc.rect(0, 0, 150, 15, "F");
    doc.rect(0, 190, 150, 30, "F");

    // Logo Product
    // doc.addImage(logoProduct, 'JPEG', 1, 4, 7, 7);

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.text("KẾT QUẢ TRẮC NGHIỆM DIAG HUB", 74, 9, { align: "center" });

    doc.addImage(logoBusiness, 'JPEG', 1, 188, 50, 15);
    // doc.addImage(logoProduct, 'JPEG', 4, 10, 60, 60);

    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.text("Công ty cổ phần Khoa học", 7, 203);
    doc.text("Công nghệ & Phát triển tài năng IVN", 1, 207);

    doc.text("Địa chỉ: 58 Cách Mạng, phường Tân Thành,", 70, 195);
    doc.text("quận Tân Phú, Tp. Hồ Chí Minh.", 70, 199);
    doc.text("Liên hệ: +84 944 400 607", 70, 207);
    doc.text("Email: info@toilaai.vn", 110, 207);
    // End

    doc.setFontSize(13);
    doc.setTextColor(0, 0, 0);
    doc.text(`Họ và tên:   ${sessionStorage.getItem("fullname")}`, 7, 40);
    doc.text(`Ngày tháng năm sinh:   ${sessionStorage.getItem("dob")}`, 7, 50);
    doc.text(`Số điện thoại:   ${sessionStorage.getItem("phoneNumber")}`, 7, 60);
    doc.text(`Địa chỉ emal:   ${sessionStorage.getItem("email")}`, 7, 70);
    doc.text(`Công việc hiện tại:   ${sessionStorage.getItem("job")}`, 7, 80);

    doc.text("Kết quả", 7, 110);

    doc.setLineWidth(1);
    doc.setDrawColor(255, 0, 255);
    doc.setTextColor(255, 0, 255);
    doc.setFontSize(15);

    doc.text(`${sessionStorage.getItem("resultString")}`, 7, 120);

    doc.setLineWidth(1);
    doc.setDrawColor(0, 250, 154);
    doc.setTextColor(0, 128, 0);
    doc.setFontSize(15);

    doc.text(`${sessionStorage.getItem("motivationString")}`, 7, 130);

    doc.setTextColor(255, 215, 0);
    doc.text(`${sessionStorage.getItem("namedOwnerString")}`, 7, 140);

    // if (location.state.finalNumberOwner === "10") {
    //   doc.text(`${location.state.finalNumberOwner}`, 109, 130);
    // } else if (location.state.finalNumberOwner === "11/2") {
    //   doc.text(`${location.state.finalNumberOwner}`, 104, 130);
    // } else if (location.state.finalNumberOwner === "22/4") {
    //   doc.text(`${location.state.finalNumberOwner}`, 100, 130);
    // } else if (location.state.finalNumberOwner === "1") {
    //   doc.text(`${location.state.finalNumberOwner}`, 113, 130);
    // } else {
    //   doc.text(`${location.state.finalNumberOwner}`, 112, 130);
    // }
    // doc.circle(117, 125, 25);

    doc.save(`Kết quả Diag Hub - ${sessionStorage.getItem("fullname")}.pdf`);
  }

  return (
    <div className="flex justify-center items-center flex-col w-full h-max pl-5 pr-5 pt-8 pb-8 bg-white rounded-b-md">
      {/* thanks */}
      <div className="w-full h-max flex justify-center items-center font-semibold">
        <p>CẢM ƠN {sessionStorage.getItem("name")} ĐÃ THAM GIA BÀI TRẮC NGHIỆM</p>
      </div>

      {/* divider */}
      <div className="w-full h-max mt-3 mb-3 border-t-2">
      </div>

      {/* result form */}
      <div className="space-y-7 w-full h-max flex flex-col">
        {/* title */}
        <div className="font-semibold text-lg text-cyan-600 flex justify-center items-center">
          <p>KẾT QUẢ CỦA {sessionStorage.getItem("name")}</p>
        </div>

        {/* result */}
        <div className="
          text-4xl font-bold flex justify-center items-center
          text-transparent bg-clip-text
          bg-gradient-to-r from-rose-500 via-pink-500 to-fuchsia-500
        ">
          <p>{sessionStorage.getItem("resultString")}</p>
        </div>
      </div>

      {/* divider */}
      <div className="w-full h-max mt-3 mb-3 border-t-2">
      </div>

      {/* other website */}
      <div className="w-full h-max flex justify-between">
        {/* website connect */}
        <div className="relative w-full h-max flex flex-col">


          {sessionStorage.getItem("type") === "student" ?
            <a href="https://ivntalent.vn/">
              <button
                className="
                  flex text-sm space-x-2 shadow-md
                  font-semibold justify-center
                  items-center bg-blue-500
                  pl-2 pr-2 pt-1 pb-1 rounded-md
                  w-max text-white
                  hover:text-slate-100 hover:bg-blue-400
                ">
                <ArrowBackTwoToneIcon fontSize="small" />
                <p>Trở lại website</p>
              </button>
            </a>
            :
            <a href="https://ivntalent.vn/">
              <button
                className="
                flex text-sm space-x-2 shadow-md
                font-semibold justify-center
                items-center bg-blue-500
                pl-2 pr-2 pt-1 pb-1 rounded-md
                w-max text-white
                hover:text-slate-100 hover:bg-blue-400
              ">
                <ArrowBackTwoToneIcon fontSize="small" />
                <p>Trở lại website</p>
              </button>
            </a>
          }

          {/* website fields */}
          <div className="flex flex-col text-xs mt-3">
            <p>Tôi là ai: <span className="text-blue-500 hover:text-red-500"><a href="https://toilaai.vn/" target="blank">https://toilaai.vn/</a></span></p>
            <p>Đồng hành cùng con: <span className="text-blue-500 hover:text-red-500"><a href="https://donghanhcungcon.com.vn/" target="blank">https://donghanhcungcon.com.vn/</a></span></p>
            <p>Viện IVN: <span className="text-blue-500 hover:text-red-500"><a href="https://ivntalent.vn/" target="blank">https://ivntalent.vn/</a></span></p>
          </div>

          {/* download button */}
          <button onClick={_onClickDownloadPDF} className="flex absolute top-0 right-0 text-sm space-x-2 shadow-md font-semibold justify-center items-center bg-yellow-500 pl-2 pr-2 pt-1 pb-1 rounded-md hover:text-slate-100 hover:bg-yellow-400">
            <CloudDownloadTwoToneIcon fontSize="small" />
            <p>Tải kết quả</p>
          </button>
        </div>

      </div>

      {/* divider */}
      <div className="w-full h-max mt-3 mb-3">
      </div>

      {/* logo fields */}
      <div className="flex items-center justify-between w-full md:h-[3rem] h-[2rem]">
        {/* business */}
        <img
          className="h-full"
          src={logoBusiness}
          alt=""
        />

        {/* product */}
        <img
          className="h-full"
          src={logoProduct}
          alt=""
        />

        {/* institute */}
        <img
          className="h-full"
          src={logoInstitute}
          alt=""
        />
      </div>
    </div>
  )
}

export default FormContent;
